<ng-container *ngFor="let item of items">
  <label class="radio_label"> {{label}}
    <input type="radio" [value]="item.value" [ngModel]="value" (ngModelChange)="change($event)"
      [name]="item.name" />{{item.name}}
    <span (click)="onChange(checked)"></span>
  </label>
</ng-container>
